// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerforall {
  margin-top: 3%;
  display: flex;
  justify-content: space-between;
  font-family: "Poppins";
}
.headerforall .leftHeader h1 {
  font-weight: 600;
}
.headerforall .rightHeader a.inActive {
  color: #3fb9ea;
  text-decoration: none;
}

.paragraphforall {
  font-family: "Poppins";
}
.paragraphforall h5.heading {
  color: #d60000;
  font-weight: 700;
}
.paragraphforall h6.subHeading {
  font-weight: 700;
}
.paragraphforall h6.noteHeading {
  font-size: 16px;
}
.paragraphforall ul.lists li.list {
  list-style-type: number;
}
.paragraphforall p.note {
  font-style: italic;
  font-size: 14px;
}
.paragraphforall p.disc {
  font-size: 1rem;
  font-weight: 100 !important;
}

.footerSectionContainer {
  background: #032b3b;
  padding: 3% 0;
}

.scoreBtnFooter {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #28b1e7;
  background: transparent;
  border: none;
  font-family: "Poppins";
}
.scoreBtnFooter::after {
  position: absolute;
  bottom: -2px;
  left: 0;
  content: "";
  width: 100%;
  height: 2px;
  background: #bd0000;
  transform: scale(0, 1);
  transform-origin: right top;
  transition: transform 0.3s;
}
.scoreBtnFooter:hover {
  color: #bd0000;
}
.scoreBtnFooter:hover::after {
  transform-origin: left top;
  transform: scale(1, 1);
}

.footerLinksContainer {
  padding: 20px 0;
}
.footerLinksContainer .footerLinks {
  padding: 0;
}
.footerLinksContainer .footerLinks .footerLinksHere h4 {
  padding-left: 10px;
  color: #fff;
  text-decoration: underline;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists {
  list-style: none;
  padding: 0;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list {
  margin: 10px;
  transition: transform 0.3s;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list a {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #28b1e7;
  background: transparent;
  border: none;
  font-family: "Poppins";
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list a::after {
  position: absolute;
  bottom: -2px;
  left: 0;
  content: "";
  width: 100%;
  height: 2px;
  background: #bd0000;
  transform: scale(0, 1);
  transform-origin: right top;
  transition: transform 0.3s;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list a:hover {
  color: #bd0000;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list a:hover::after {
  transform-origin: left top;
  transform: scale(1, 1);
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list:hover {
  transform: translateY(-5px);
}
.footerLinksContainer .footerLinks .footerLinksHere .lists:hover h2 {
  color: #d60000;
}

.attentionInvestor {
  text-align: left;
}
.attentionInvestor .attentionHeaders ul {
  list-style: none;
  color: #fff;
  padding: 0;
  margin: 0;
}
.attentionInvestor .attentionHeaders ul li {
  display: inline-block;
}
.attentionInvestor .attentionHeaders ul li:not(:first-child) {
  margin-left: 10px;
  color: #28b1e7;
}
.attentionInvestor .scrolling_Text {
  height: 40px;
  overflow: hidden;
  position: relative;
  background: transparent;
}
.attentionInvestor .scrolling_Text p.scroll {
  text-align: left;
  position: absolute;
  font-family: "Poppins";
  width: 100%;
  height: 100%;
  color: #28b1e7;
  font-weight: 700;
  margin: 0;
  line-height: 20px;
  white-space: nowrap;
  animation: scroll 25s linear infinite;
}
@keyframes scroll {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.attentionInvestor .scrolling_Text p.scroll:hover {
  animation-play-state: paused;
  cursor: pointer;
  color: #bd0000;
}

.usefulLinksContainer {
  margin: 0;
  display: flex;
  color: #ecf0f1;
}
.usefulLinksContainer span {
  color: #3fb9ea;
}
.usefulLinksContainer ul {
  display: flex;
  list-style-type: none;
  margin: 0;
}
.usefulLinksContainer ul li {
  padding: 0 10px;
}
.usefulLinksContainer ul li a {
  color: #ecf0f1;
  text-decoration: none;
}
.usefulLinksContainer ul li a:hover {
  color: #bd0000;
}

.copyrightContainer {
  padding-top: 20px;
}
.copyrightContainer .centerRight {
  display: flex;
  justify-content: center;
}
.copyrightContainer .centerRight p {
  text-align: center;
  color: #ecf0f1;
}
.copyrightContainer .centerRight p a {
  color: #28b1e7;
  text-decoration: none;
}

.accordion-container {
  width: 100%;
}

.accordion-item {
  border: 1px solid #6c757d;
  border-radius: 5px;
  margin-bottom: 15px;
  background-color: #fff;
  transition: border 0.3s;
}
.accordion-item.active {
  border: 1px solid #007bff;
}
.accordion-item.active .accordion-header {
  background-color: #007bff;
  color: #fff;
}
.accordion-item .accordion-header {
  background-color: #6c757d;
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.accordion-item .accordion-header .accordion-title {
  font-weight: bold;
}
.accordion-item .accordion-header .accordion-icon {
  transform: rotate(90deg);
  transition: transform 0.3s;
}
.accordion-item .accordion-header .accordion-icon.active {
  transform: rotate(0deg);
}
.accordion-item .accordion-body {
  padding: 10px;
}

@media (max-width: 768px) {
  .accordion-header {
    flex-direction: column;
  }
  .accordion-header .accordion-title {
    margin-bottom: 5px;
  }
  .accordion-header .accordion-icon {
    transform: rotate(0deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/Defaults/Footer/Style.scss"],"names":[],"mappings":"AAOA;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;AANF;AASI;EACE,gBAAA;AAPN;AAYI;EACE,cApBI;EAqBJ,qBAAA;AAVN;;AAgBA;EACE,sBAAA;AAbF;AAeE;EACE,cA9BQ;EA+BR,gBAAA;AAbJ;AAgBE;EACE,gBAAA;AAdJ;AAiBE;EACE,eAAA;AAfJ;AAmBI;EACE,uBAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,eAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,2BAAA;AApBJ;;AAyBA;EACE,mBAAA;EACA,aAAA;AAtBF;;AA0BA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AAvBF;AAyBE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AAvBJ;AA0BE;EACE,cAAA;AAxBJ;AA2BE;EACE,0BAAA;EACA,sBAAA;AAzBJ;;AA8BA;EACE,eAAA;AA3BF;AA6BE;EACE,UAAA;AA3BJ;AA8BM;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;AA5BR;AA+BM;EACE,gBAAA;EACA,UAAA;AA7BR;AA+BQ;EACE,YAAA;EACA,0BAAA;AA7BV;AA+BU;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AA7BZ;AA+BY;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AA7Bd;AAgCY;EACE,cAAA;AA9Bd;AAiCY;EACE,0BAAA;EACA,sBAAA;AA/Bd;AAmCU;EACE,2BAAA;AAjCZ;AAqCQ;EACE,cA9JE;AA2HZ;;AA2CA;EACE,gBAAA;AAxCF;AA2CI;EACE,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAzCN;AA2CM;EACE,qBAAA;AAzCR;AA2CQ;EACE,iBAAA;EACA,cAAA;AAzCV;AA+CE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AA7CJ;AA+CI;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;AA7CN;AA+CM;EACE;IACE,2BAAA;EA7CR;EAgDM;IACE,4BAAA;EA9CR;AACF;AAiDM;EACE,4BAAA;EACA,eAAA;EACA,cAAA;AA/CR;;AAwDA;EACE,SAAA;EACA,aAAA;EACA,cAAA;AArDF;AAuDE;EACE,cA3OM;AAsLV;AAwDE;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AAtDJ;AAwDI;EACE,eAAA;AAtDN;AAwDM;EACE,cAAA;EACA,qBAAA;AAtDR;AAwDQ;EACE,cAAA;AAtDV;;AA8DA;EACE,iBAAA;AA3DF;AA6DE;EACE,aAAA;EACA,uBAAA;AA3DJ;AA6DI;EACE,kBAAA;EACA,cAAA;AA3DN;AA6DM;EACE,cAAA;EACA,qBAAA;AA3DR;;AA4EA;EACE,WAAA;AAzEF;;AA6EA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AA1EF;AAgFE;EACE,yBAAA;AA9EJ;AAgFI;EACE,yBA7BU;EA8BV,WAAA;AA9EN;AAkFE;EACE,yBAhCc;EAiCd,aAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AAhFJ;AAkFI;EACE,iBAAA;AAhFN;AAmFI;EACE,wBAAA;EACA,0BAAA;AAjFN;AAmFM;EACE,uBAAA;AAjFR;AAsFE;EACE,aAAA;AApFJ;;AAyFA;EACE;IACE,sBAAA;EAtFF;EAwFE;IACE,kBAAA;EAtFJ;EAyFE;IACE,uBAAA;EAvFJ;AACF","sourcesContent":["// Color Variables\r\n$primary: #3fb9ea;\r\n$secondary: #d60000;\r\n$hover: #b80000;\r\n$gray: #808080;\r\n\r\n// *** Styles For All Links\r\n.headerforall {\r\n  margin-top: 3%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-family: \"Poppins\";\r\n\r\n  .leftHeader {\r\n    h1 {\r\n      font-weight: 600;\r\n    }\r\n  }\r\n\r\n  .rightHeader {\r\n    a.inActive {\r\n      color: $primary;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n// *** Disclaimer\r\n.paragraphforall {\r\n  font-family: \"Poppins\";\r\n\r\n  h5.heading {\r\n    color: $secondary;\r\n    font-weight: 700;\r\n  }\r\n\r\n  h6.subHeading {\r\n    font-weight: 700;\r\n  }\r\n\r\n  h6.noteHeading {\r\n    font-size: 16px;\r\n  }\r\n\r\n  ul.lists {\r\n    li.list {\r\n      list-style-type: number;\r\n    }\r\n  }\r\n\r\n  p.note {\r\n    font-style: italic;\r\n    font-size: 14px;\r\n  }\r\n\r\n  p.disc {\r\n    font-size: 1rem;\r\n    font-weight: 100 !important;\r\n  }\r\n}\r\n\r\n// *** Footer Styles\r\n.footerSectionContainer {\r\n  background: #032b3b;\r\n  padding: 3% 0;\r\n}\r\n\r\n// Score Btn Footer\r\n.scoreBtnFooter {\r\n  position: relative;\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  color: darken($primary, 5%);\r\n  background: transparent;\r\n  border: none;\r\n  font-family: \"Poppins\";\r\n\r\n  &::after {\r\n    position: absolute;\r\n    bottom: -2px;\r\n    left: 0;\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 2px;\r\n    background: darken($secondary, 5%);\r\n    transform: scale(0, 1);\r\n    transform-origin: right top;\r\n    transition: transform 0.3s;\r\n  }\r\n\r\n  &:hover {\r\n    color: darken($secondary, 5%);\r\n  }\r\n\r\n  &:hover::after {\r\n    transform-origin: left top;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n\r\n// Footer links\r\n.footerLinksContainer {\r\n  padding: 20px 0;\r\n\r\n  .footerLinks {\r\n    padding: 0;\r\n\r\n    .footerLinksHere {\r\n      h4 {\r\n        padding-left: 10px;\r\n        color: #fff;\r\n        text-decoration: underline;\r\n      }\r\n\r\n      .lists {\r\n        list-style: none;\r\n        padding: 0;\r\n\r\n        .list {\r\n          margin: 10px;\r\n          transition: transform 0.3s;\r\n\r\n          a {\r\n            position: relative;\r\n            display: inline-block;\r\n            text-decoration: none;\r\n            color: darken($primary, 5%);\r\n            background: transparent;\r\n            border: none;\r\n            font-family: \"Poppins\";\r\n\r\n            &::after {\r\n              position: absolute;\r\n              bottom: -2px;\r\n              left: 0;\r\n              content: \"\";\r\n              width: 100%;\r\n              height: 2px;\r\n              background: darken($secondary, 5%);\r\n              transform: scale(0, 1);\r\n              transform-origin: right top;\r\n              transition: transform 0.3s;\r\n            }\r\n\r\n            &:hover {\r\n              color: darken($secondary, 5%);\r\n            }\r\n\r\n            &:hover::after {\r\n              transform-origin: left top;\r\n              transform: scale(1, 1);\r\n            }\r\n          }\r\n\r\n          &:hover {\r\n            transform: translateY(-5px);\r\n          }\r\n        }\r\n\r\n        &:hover h2 {\r\n          color: $secondary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Attention Investor\r\n.attentionInvestor {\r\n  text-align: left;\r\n\r\n  .attentionHeaders {\r\n    ul {\r\n      list-style: none;\r\n      color: #fff;\r\n      padding: 0;\r\n      margin: 0;\r\n\r\n      li {\r\n        display: inline-block;\r\n\r\n        &:not(:first-child) {\r\n          margin-left: 10px;\r\n          color: darken($primary, 5%);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .scrolling_Text {\r\n    height: 40px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    background: transparent;\r\n\r\n    p.scroll {\r\n      text-align: left;\r\n      position: absolute;\r\n      font-family: \"Poppins\";\r\n      width: 100%;\r\n      height: 100%;\r\n      color: darken($primary, 5%);\r\n      font-weight: 700;\r\n      margin: 0;\r\n      line-height: 20px;\r\n      white-space: nowrap;\r\n      animation: scroll 25s linear infinite;\r\n\r\n      @keyframes scroll {\r\n        0% {\r\n          transform: translateX(100%);\r\n        }\r\n\r\n        100% {\r\n          transform: translateX(-100%);\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        animation-play-state: paused;\r\n        cursor: pointer;\r\n        color: darken($secondary, 5%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n// Useful Links\r\n.usefulLinksContainer {\r\n  margin: 0;\r\n  display: flex;\r\n  color: #ecf0f1;\r\n\r\n  span {\r\n    color: $primary;\r\n  }\r\n\r\n  ul {\r\n    display: flex;\r\n    list-style-type: none;\r\n    margin: 0;\r\n\r\n    li {\r\n      padding: 0 10px;\r\n\r\n      a {\r\n        color: #ecf0f1;\r\n        text-decoration: none;\r\n\r\n        &:hover {\r\n          color: darken($secondary, 5%);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Copyright\r\n.copyrightContainer {\r\n  padding-top: 20px;\r\n\r\n  .centerRight {\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    p {\r\n      text-align: center;\r\n      color: #ecf0f1;\r\n\r\n      a {\r\n        color: darken($primary, 5%);\r\n        text-decoration: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// NSE Arbitration Rules\r\n// Define a primary color for the accordion\r\n$primary-color: #007bff;\r\n\r\n// Define a secondary color for the accordion\r\n$secondary-color: #6c757d;\r\n\r\n// Define a transition duration for smooth animations\r\n$transition-duration: 0.3s;\r\n\r\n// Accordion container\r\n.accordion-container {\r\n  width: 100%;\r\n}\r\n\r\n// Accordion items\r\n.accordion-item {\r\n  border: 1px solid $secondary-color;\r\n  border-radius: 5px;\r\n  margin-bottom: 15px;\r\n  background-color: #fff;\r\n  transition: border $transition-duration;\r\n\r\n  &:hover {\r\n    // border: 1px solid $primary-color;\r\n  }\r\n\r\n  &.active {\r\n    border: 1px solid $primary-color;\r\n\r\n    .accordion-header {\r\n      background-color: $primary-color;\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  .accordion-header {\r\n    background-color: $secondary-color;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    .accordion-title {\r\n      font-weight: bold;\r\n    }\r\n\r\n    .accordion-icon {\r\n      transform: rotate(90deg);\r\n      transition: transform $transition-duration;\r\n\r\n      &.active {\r\n        transform: rotate(0deg);\r\n      }\r\n    }\r\n  }\r\n\r\n  .accordion-body {\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\n// Media query for smaller screens\r\n@media (max-width: 768px) {\r\n  .accordion-header {\r\n    flex-direction: column;\r\n\r\n    .accordion-title {\r\n      margin-bottom: 5px;\r\n    }\r\n\r\n    .accordion-icon {\r\n      transform: rotate(0deg);\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
